import React, { ReactElement, useCallback, useMemo, useState } from 'react';
import useConfirmationProps from './useConfirmationProps';
import WarningConfirmationModal from '../WarningConfirmationModal';

const useWarningConfirmation = ({
  title,
  continueText,
  isDestructive,
}: {
  title: string;
  continueText?: string;
  isDestructive?: boolean;
}) => {
  const [body, setBody] = useState<string | ReactElement>('');
  const { getConfirmation, onConfirmed, onCancelled, isOpen } =
    useConfirmationProps();

  const DangerConfirmation = useMemo(
    () => (
      <WarningConfirmationModal
        isOpen={isOpen}
        close={onCancelled}
        title={title}
        body={body}
        onConfirmed={onConfirmed}
        continueText={continueText}
        isDestructive={isDestructive}
      />
    ),
    [
      body,
      continueText,
      isDestructive,
      isOpen,
      onCancelled,
      onConfirmed,
      title,
    ],
  );

  const getConfirmationThat = useCallback(
    (confirmationBody: string | ReactElement) => {
      setBody(confirmationBody);
      return getConfirmation();
    },
    [getConfirmation],
  );

  return { getConfirmationThat, DangerConfirmation };
};

export default useWarningConfirmation;
